document.addEventListener("DOMContentLoaded", function () {

	if (document.body.classList.contains('wp-admin')) return;

	// Start: Sticky Footer
	let pageHeight = document.getElementById("page").offsetHeight;
	let viewportHeight = window.innerHeight;
	let footer = document.querySelector(".rwest-footer");

	const debounce = func => {
		let timer;

		return function (event) {
			if (timer) clearTimeout(timer);
			timer = setTimeout(func, 100, event);
		};
	};

	const sticky = () => {
		if (pageHeight < viewportHeight && window.innerWidth >= 769) {
			footer.style.position = "absolute";
			footer.style.bottom = "0";
			footer.style.width = "100%";
		} else {
			footer.style.position = "relative";
		}
	};

	sticky();

	window.addEventListener(
		"resize",
		debounce(function (e) {
			sticky();
		})
	);
});
